export const getTrendType = (trendDirection: string): 'positive' | 'negative' | 'neutral' => {
  switch (trendDirection.toLowerCase()) {
    case 'up':
    case 'positive':
      return 'positive';
    case 'down':
    case 'negative':
      return 'negative';
    default:
      return 'neutral';
  }
};
